import axios from "axios"
import { rutas } from "../rutas/rutas"
import { getCookie } from "../utils/getCookies"

export const completarConstruccion = async(id)=>{
   
        const token = getCookie('token')
         return axios({
            url: rutas.completarConstruccion,
            data: {id},
            method: 'post',
            headers:{
                token: token
            }
        })
    
       
 
}
  